<template>
  <div class="tour-popup">
    <div id="modal_welcome" class="modal welcome-modal" data-backdrop="static" role="dialog"
      :class="{ 'displayBlock': displaySide }">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <p class="virtual-tour-header m-0 pl-16">{{$t('virtualTour')}}</p>
            <img src="/static/images/icons/virtualtour_close_icon.svg" class="welcome-close-btn" data-dismiss="modal" @click="stopTour()" />
          </div>
          <div class="modal-body pb-0 pt-0">
            <p class="modal-body-header">Conformity Declaration Management</p>
            <p class="body-welcome-txt m-0">{{ $t('welcome') }} {{ userName }}!</p>
            <p class="body-txt sub-text">
              {{ $t('welcomeMsg1') }}.
            </p>
          </div>
          <div class="modal-footer pt-0">
              <div>
                <button type="button" class="btn btn-link skip-link" data-dismiss="modal" @click="stopTour()">
                  {{ $t('skipTour') }}
                </button>
              </div>
              <div class="start-tour-btn-section">
                <router-link to="/layout/dashboard">
                  <button type="button" class="btn start-tour-btn" @click="startTour(); emitEvent();">
                    {{ $t('startTour') }}
                  </button>
                </router-link>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { updateRamsTour } from '../../apis/dashboard';
import EventBus from '../../utils/event-bus';
import { getUserData } from '../../apis/profile';

export default {
  props: ['displaySide'],
  data() {
    return {
      userData: {},
    };
  },
  methods: {
    emitEvent() {
      EventBus.$emit('tourStart');
      // this.$emit('mobilesidebar');
    },
    async startTour() {
      $('#modal_welcome').modal('hide');
      EventBus.$emit('doNotBlurSideMenu');
      $('#modal_dashboard').modal({
        backdrop: 'static',
        keyboard: false,
      });
      await this.stopTour();
    },
    async stopTour() {
      const data = {
        new_user: false,
      };
      await updateRamsTour(data);
    },
  },
  computed: {
    userName() {
      return `${this.userData.first_name} ${this.userData.last_name}`;
    },
  },
  async mounted() {
    this.userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : await getUserData();
  },
};
</script>

<style scoped>
.modal-content{
  border-radius: 6px;
}
.modal-body {
  padding-left: 24px;
}
.modal-body-header {
  color:#CA0123;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  padding-top: 24px;
}
.virtual-tour-header {
  align-self: center;
  color: #1A1A1A;
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
}
.tour-popup .modal-header{
  display: flex;
  border-bottom:  1px solid #D3D3D3;
  height: 60px;
}
.footer-img{
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  width: 100%;
  height: 100%;
}
.pt-0{
  padding-top: 0px;
}
.pb-0{
  padding-bottom: 0px;
}
.start-tour-btn-section{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.start-tour-btn, .start-tour-btn:hover,
.start-tour-btn:focus{
    background-color: #01518A;
    border: none;
    cursor: pointer;
    color: #ffffff;
    line-height: 25px;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    margin-top: 0px;
    text-align: center;
    padding: 6px 16px;
}
.skip-link,.skip-link:hover {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  padding: 6px 16px !important;
  color: #404040;
  padding: 0px;
  border: none;
  background: #E6E6E6;
  margin-right: 16px;
  text-decoration: none;
}
.inmetro-sdc-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px;
}
.welcome-close-btn{
  cursor: pointer;
  position: absolute;
  right: 21px;
  top: 23px;
}
.modal-footer{
  margin-top: 52px;
  padding: 0px;
  display: flex;
  justify-content: flex-end;
  background: #FAFAF9 !important;
  height: 76px;
  align-items: center;
  border-radius: 6px;
}
.welcome-modal .modal-dialog{
  width: 500px;
}
.displaySide {
  display: block !important;
}
.tour-popup .logo {
  position: absolute;
  margin: 40px auto;
  left: 0;
  right: 0;
  text-align: center;
  max-height: 80px;
}
.tour-popup .start-btn {
  width: 185px;
  margin-top: 35px;
}
.body-welcome-txt{
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
  margin-top: 16px;
  margin-bottom: 8px;
}
.sub-text{
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
    margin: 0px auto 0;
}
.check-txt{
  font-weight: 300;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #0B3C61;
}
.tour-popup .modal-dashbrd .btn-modal-footer {
  margin-top: 0px;
}
@media screen and (max-width: 767px) {
  .welcome-modal {
    display: none !important;
  }
}
</style>
